export class ListarChamados {
  codigoPolo?: number;
  codigoDiretoria: number;
  nomeDiretoria: string;
  codigoEscola: number;
  nomeEscola: string;
  codigoTurno?: number;
  nomeTurno: string;
  codigoTurma?: number;
  descricaoTurma?: string;
  codigoCategoria: number;
  nomeCategoria: string;
  codigoSubCategoria?: number;
  nomeSubCategoria: string;
  codigoGravidade?: number;
  nomeGravidade: string;
  codigoAgendamento: number;
  codigoChamado: number;
  codigoEnvolvido: number;
  nomeEnvolvido: string;
  status: number;
  dsStatus: string;
  nomePsicologo: string;
  tipoEnvolvidoAgendamento: string;
  descricaoChamado: string;
  dataChamado: Date;
  dataInclusao: Date;
  horasAtras: string;
  imagemChamado: string[] = [];
  tipoEnvolvido: number;
  dsEnvolvido: string;
  tipoPessoa: number;
  dsPessoa: string;
  descricaoOutros?: string;
  iniciaisNome?: string;
  foto?: string;
  dsGravidade?: string;
  temFoto: boolean;
  equipeEscolar?: FuncionarioEnvolvido;
  aluno?: AlunoEnvolvido;
  ordenacaoCrescente: boolean;
  filtroStatusEnvolvido?: number;
  dataInicio?: Date;
  dataFim?: Date;
  getFoto?: boolean;
  dsTipoAcao?: string;
  dsTipoNotificacao?: string;
  codigoPerfil?: number;
  pagina?: number;
  numeroBOSSP?: number;
  semEnvolvido: boolean;
  tpPessoa: number[] = [];
  anoAtual?: number;
  dataAgendamento?: Date;
  atividadeDiretoria: boolean = false;
  codigoTipoEnsino?: number;
  nomeTipoEnsino?: string;
  codigoPOC?: number;
  nomePOC?: string;
}

export class AlunoEnvolvido {
  codigoAluno: number;
  nomeAluno?: string;
  ra?: string;
  digitoRa?: string;
  ufRa?: string;
  dsStatusEnvolvido?: string;
  descricaoTurma?: string;
  statusEnvolvido: number;
  cpf?: string;
}

export class FuncionarioEnvolvido {
  idUser: number;
  nome?: string;
  cpf?: string;
  email?: string;
}
